import React, { useEffect } from 'react';

import {
  EncounterTaskStatusEnum,
  useGetEncounterTaskByEncounterTaskIdLazyQuery,
} from 'generated/graphql';

import UI from 'ui';
import { Grid } from '../StyledEncounterPrint';
import { Tokens } from 'config';

const ClinicianBillingSummary = ({
  taskId,
}: {
  taskId?: number;
}): JSX.Element | null => {
  // Task may not exist on this encounter
  if (taskId === null || taskId === undefined) return null;

  const [getEncounterTask, { data, loading }] =
    useGetEncounterTaskByEncounterTaskIdLazyQuery();

  const task = data?.encounterTask;
  const billingCodeList = task?.billingDiagnosticsList;

  useEffect(() => {
    if (taskId) {
      getEncounterTask({
        variables: {
          id: taskId,
          isClinicianBillingTask: true,
        },
      });
    }
  }, [taskId]);

  if (loading) return <UI.Spinner centered />;

  // ASSUMPTION: SKIPPED TASKS SHOULD DISPLAY NOTHING
  if (task?.status === EncounterTaskStatusEnum.SKIPPED) return null;

  // Billing Codes may not exist on this encounter task (defensive)
  if (
    billingCodeList === null ||
    billingCodeList === undefined ||
    billingCodeList.length === 0
  )
    return null;

  return (
    <>
      <Grid style={{ marginBottom: Tokens.rhythm }}>
        <div>
          <strong>CPT code:</strong>
        </div>
        <div>
          <strong>Name:</strong>
        </div>
      </Grid>
      <div>
        {billingCodeList.map((code) => {
          return (
            <Grid key={code.encounterTaskId}>
              <div>{code.procedureCodeReference?.code ?? '-'}</div>
              <div>{code.procedureCodeReference?.name ?? '-'}</div>
            </Grid>
          );
        })}
      </div>
    </>
  );
};

export default ClinicianBillingSummary;
